import React, { useEffect } from 'react';

import ExtractorService from 'common/services/Extractor';

const GooddaysReviewNoteWidget = ({ field, reference }) => {
  const critizrEnable = field ? ExtractorService.extractBoolean(field) : false;

  useEffect(() => {
    if (!critizrEnable || typeof document === 'undefined') return;

    const titleText = 'Critizr feedback widget';

    const setTitles = (root = document) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('iframe.cz-embed').forEach((el) => {
        if (!el.title) el.title = titleText;
      });
    };

    setTitles(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          try {
            if (node.matches && node.matches('iframe.cz-embed')) {
              if (!node.title) node.title = titleText;
            }
            if (node.querySelectorAll) setTitles(node);
          } catch (e) {
            // ignore
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [critizrEnable, reference]);

  if (!critizrEnable) {
    return null;
  }

  return (
    <aside
      style={{ height: '103px' }}
      aria-label="Widget de notation Critizr"
      itemProp="aggregateRating"
      itemScope
      itemType="https://schema.org/AggregateRating"
    >
      <a
        className="critizr-widget"
        href={`https://critizr.com/widgets/vog-vog/${reference}/`}
        data-type="store_button:rating_satisfaction"
        aria-label="Voir les avis et noter ce salon via Critizr"
        rel="noopener noreferrer"
      >
        Critizr: Envoyer mon avis
      </a>
    </aside>
  );
};
export default GooddaysReviewNoteWidget;
